// third-party
import { combineReducers } from 'redux'

// project import
import menu from './menu'
import listgrid from './listgrid';

// ==============================|| COMBINE REDUCERS ||============================== //

const reducers = combineReducers({ menu, listgrid })

export default reducers
